
import Vue from 'vue'
import TelephonyDisambiguation from '@/views/telephony/TelephonyDisambiguation.vue'
import TelephonyRedirectShell from '@/views/telephony/TelephonyRedirectShell.vue'
import { EventBus } from '@/plugins/eventBus'
import { mutations } from '@/plugins/state'
import type { TelephonyMatch } from '@/utils/telephonyLookup'
import { buildFolderPathForMatch } from '@/utils/telephonyNavigation'
import { formatPhoneForDisplay } from '@/utils/telephonyMessages'
import type { TelephonyNotFoundContext } from '@/utils/telephonyMessages'
import {
  buildTelephonyRedirectViewState,
  parseTelephonySpaceId,
  phoneFromRouteQuery,
  runTelephonyLookup,
} from '@/utils/telephonyRedirect'

export default Vue.extend({
  name: 'TelephonyFolderRedirect',
  components: {
    TelephonyDisambiguation,
    TelephonyRedirectShell,
  },
  props: {
    spaceId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      showDisambiguation: false,
      matches: [] as TelephonyMatch[],
      notFoundContext: null as TelephonyNotFoundContext | null,
      errorMessage: '',
    }
  },
  async mounted() {
    await this.runRedirect()
  },
  computed: {
    callerPhoneDisplay(): string {
      return formatPhoneForDisplay(phoneFromRouteQuery(this.$route.query))
    },
  },
  methods: {
    async runRedirect() {
      this.loading = true
      this.showDisambiguation = false
      this.notFoundContext = null
      this.errorMessage = ''
      this.matches = []

      const phone = phoneFromRouteQuery(this.$route.query)
      const outcome = await runTelephonyLookup(
        'folder',
        parseTelephonySpaceId(this.spaceId),
        phone
      )
      const viewState = buildTelephonyRedirectViewState(
        outcome,
        (key) => this.$vuetify.lang.t(key)
      )
      this.loading = viewState.loading
      this.notFoundContext = viewState.notFoundContext
      this.errorMessage = viewState.errorMessage

      if (!viewState.canProceed) return

      if (outcome.status === 'success' && outcome.results.length === 1) {
        this.navigateToFolder(outcome.results[0])
        return
      }

      if (outcome.status === 'success') {
        this.loading = false
        this.matches = outcome.results
        this.showDisambiguation = true
      }
    },
    navigateToFolder(match: TelephonyMatch) {
      if (match.kind === 'worker') {
        mutations.setView('application', 'worker_list', 'split-pane')
        EventBus.$emit('notification-view', { view: 'split-pane' })
      }
      this.$router.replace(buildFolderPathForMatch(match))
    },
    onSelectMatch(match: TelephonyMatch) {
      this.navigateToFolder(match)
    },
  },
})
